import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "public" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M11 5.882V19.24C10.9997 19.6545 10.8531 20.0555 10.5861 20.3725C10.3191 20.6896 9.94883 20.9022 9.54044 20.9729C9.13206 21.0437 8.71181 20.968 8.35372 20.7593C7.99564 20.5506 7.7227 20.2222 7.583 19.832L5.436 13.682M5.436 13.682C4.58722 13.3211 3.88918 12.6791 3.46003 11.8627C3.03087 11.0463 2.89695 10.1067 3.08093 9.2029C3.26491 8.29912 3.75549 7.48665 4.46965 6.903C5.18381 6.31935 6.07768 6.00035 7 6H8.832C12.932 6 16.457 4.766 18 3V17C16.457 15.234 12.933 14 8.832 14H7C6.46263 14.0008 5.93065 13.892 5.436 13.682ZM18 13C18.7956 13 19.5587 12.6839 20.1213 12.1213C20.6839 11.5587 21 10.7956 21 10C21 9.20435 20.6839 8.44129 20.1213 7.87868C19.5587 7.31607 18.7956 7 18 7V13Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }